<template>
  <!-- <div v-if="isMobile"> -->
  <div class="mobile">
    <component :is="currentLayout"> </component>
    <router-view v-slot="{ Component }">
        <keep-alive :include="appStore.includeList">
          <component :is="Component" />
        </keep-alive>
    </router-view>
  </div>
  <!-- <div v-else>
    <component :is="currentLayout">
      <router-view v-slot="{ Component }">
          <keep-alive :include="appStore.includeList">
            <component :is="Component" />
          </keep-alive>
      </router-view>
    </component>
  </div> -->
</template>

<script setup>
import { useAppStore } from "@/stores/modules/app";

import { useLayoutStore } from "@/stores/modules/layout";
import PhoneLayout from "./phone/Index.vue";
import PcLayout from "./pc/Index.vue";
const appStore = useAppStore();

const layoutStore = useLayoutStore();
const isMobile = computed(() => {
  return layoutStore.isMobile;
});
const currentLayout = computed(() => {
  // const layout = layoutStore.isMobile ? PhoneLayout : PcLayout;
  // return layout;
  return PhoneLayout;
});
</script>
<script>
export default {
  name: "layout" // 设置组件的name属性
};
</script>
<style lang="scss" scoped>
.mobile{
  max-width: 540px; 
  margin: auto !important;
  background-image: none;
}
</style>
